<app-loading-spinner />
<div class="main-container" [class.centered]="overviewStepCompleted()">
  @if (overviewStepCompleted()) {
    <app-success-message />
  } @else {
    <mat-stepper
      orientation="horizontal"
      [linear]="true"
      #stepper
      [class.price-step-pointer]="priceStepHasPointer()"
      [class.contact-step-pointer]="contractStepHasPointer()"
      (selectionChange)="onSelectionChange($event)">
      <mat-step [aria-label]="StepperLabel.TechData" [stepControl]="generalDataFormGroup">
        <ng-template matStepLabel>{{ StepperLabel.TechData }}</ng-template>
        <app-technical-data [generalData]="generalDataFormGroup" [stepper]="stepper"></app-technical-data>
      </mat-step>
      <mat-step [aria-label]="StepperLabel.Prices" [stepControl]="priceForm" [completed]="priceStepCompleted()">
        <ng-template matStepLabel>{{ StepperLabel.Prices }}</ng-template>
        @defer (when isPriceStepVisible()) {
          @if (isPriceStepVisible()) {
            <app-price [stepper]="stepper"></app-price>
          }
        }
      </mat-step>
      <mat-step [aria-label]="StepperLabel.Contact" [stepControl]="secondStep.formGroup">
        <ng-template matStepLabel>{{ StepperLabel.Contact }}</ng-template>
        <app-contact [stepper]="stepper" #secondStep></app-contact>
      </mat-step>
      <ng-template matStepperIcon="edit" let-index="index">
        <span>{{ index + 1 }}</span>
      </ng-template>
    </mat-stepper>
  }
</div>

<app-notification />
